// Core
import React from 'react'
import { useHistory } from 'react-router-dom'

// Library
import clsx from 'clsx'
import ReactConfetti from 'react-confetti'

// Components
import Modal from 'components/ui/Modal'
import Button from 'components/Onboarding/Button/Button'

// Routes
import routes from 'routes'

// Styles
import classes from 'components/Onboarding/SignupSuccessModal/SignupSuccessModal.module.scss'

const confettiColors = [
  '#3DB14A',
  '#15B568',
  '#F77D7D',
  '#FFA500',
  '#3396FF',
  '#116BCB',
  '#A3A3A3',
]

export default function SignupSuccessModal() {
  const history = useHistory()
  return (
    <Modal
      size="xl"
      className={clsx(classes.successModal)}
      withCloseButton={false}>
      <ReactConfetti
        colors={confettiColors}
        initialVelocityX={2}
        initialVelocityY={2}
        numberOfPieces={200}
        opacity={1}
        gravity={0.1}
        recycle={false}
        tweenDuration={1000}
        run
        wind={0}
      />
      <h1>&#x1F389;</h1>
      <h2 className="text-center">Welcome to EDEE!</h2>
      <p className="text-center">Your account has been successfully created.</p>
      <p className="text-center mb-4">We&apos;re excited to help you streamline your PPC budget management with automation and insights.</p>
      <h3 className="text-center">Your Journey Begins Here</h3>
      <div className="d-flex flex-column-sm justify-content-between align-items-center">
        <div className={clsx(classes.stepInfo)}>
          <div className="mb-2">1</div>
          <h4 className="mb-2">Tell us about yourself</h4>
          <p>Help us tailor EDEE to your role and priorities</p>
        </div>
        <div className={clsx(classes.stepInfo)}>
          <div className="mb-2">2</div>
          <h4 className="mb-2">Account usage</h4>
          <p>Select your typical monthly media spend</p>
        </div>
        <div className={clsx(classes.stepInfo)}>
          <div className="mb-2">3</div>
          <h4 className="mb-2">Connect your accounts</h4>
          <p>Link your ad platforms to start importing campaign data</p>
        </div>
      </div>
      <div className="text-center mt-5">
        <Button
          title="Continue"
          onClick={() => {
            history.push(routes.onboardingProfileBusiness)
          }}
          dataCy="continue button"
        />
      </div>
    </Modal>
  )
}